var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg531",
    xmlSpace: "preserve",
    width: 300,
    height: 300,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs535"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath545"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path543",
    fill: "#0047ba",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g537",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g541",
    clipPath: "url(#clipPath545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g547",
    transform: "translate(370.0967,149.9648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 40.611,16.905 H 82.542 L 134.403,-4.683 V -124.981",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path549",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g551",
    transform: "translate(456.2041,191.7993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -49.063 C -63.659,0 -75.492,11.833 -75.492,26.43 V 72.941 H 26.43 V 26.43 C 26.43,11.833 14.597,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path553",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g555",
    transform: "translate(492.7861,264.7402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -122.227 c -3.164,0 -5.728,2.565 -5.728,5.729 v 15.485 c 0,3.164 2.564,5.729 5.728,5.729 L 0,26.943 c 3.163,0 5.729,-2.565 5.729,-5.729 V 5.729 C 5.729,2.565 3.163,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path557",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g559",
    transform: "translate(444.3203,335.6221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.058 C 24.324,0 43.996,-19.672 43.996,-43.939 H -69.291 C -69.291,-19.672 -49.619,0 -25.353,0 h 0.058",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path561",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g563",
    transform: "translate(439.3145,348.1938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -15.283 c -2.765,0 -5.006,-2.241 -5.006,-5.006 V -56.511 H 5.006 V -5.006 C 5.006,-2.241 2.765,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path565",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g567",
    transform: "translate(431.6729,264.7402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -17.769",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path569",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g571",
    transform: "translate(419.8066,225.1631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 2.084,-4.462 6.615,-7.554 11.866,-7.554 5.251,0 9.782,3.092 11.866,7.554",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path573",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 452.636,191.799 H 410.71 v -24.925 h 41.926 z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path575",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "g577",
    transform: "translate(410.71,166.8711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 20.963,-41.696 41.926,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path579",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g581",
    transform: "translate(431.6729,125.1748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -100.192",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path583",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g585",
    transform: "translate(485.7891,95.9268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 18.711 V -33.216 H -93.828",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path587",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g589",
    transform: "translate(383.6357,95.9268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 67.196",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path591",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g593",
    transform: "translate(290.6445,260.5723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -69.289 c -20.614,0 -37.326,16.711 -37.326,37.326 v 76.413 H 37.326 V 37.326 C 37.326,16.711 20.614,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path595",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g597",
    transform: "translate(342.3076,374.3115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -172.615 c -4.469,0 -8.091,3.622 -8.091,8.09 v 16.717 c 0,4.468 3.622,8.09 8.091,8.09 H 0 c 4.469,0 8.091,-3.622 8.091,-8.09 V 8.09 C 8.091,3.622 4.469,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path599",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g601",
    transform: "translate(273.8613,469.2603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0.081,0.002 c 34.272,0 62.054,-27.782 62.054,-62.053 H -97.857 c 0,34.271 27.782,62.053 62.053,62.053 h 0.081",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path603",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g605",
    transform: "translate(266.792,487.0171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -21.584 c -3.904,0 -7.069,-3.165 -7.069,-7.07 V -79.808 H 7.069 V -7.07 C 7.069,-3.165 3.904,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path607",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g609",
    transform: "translate(192.8711,449.7344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 15.249,-10.272",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path611",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g613",
    transform: "translate(319.1289,449.7344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -15.249,-10.272",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path615",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g617",
    transform: "translate(256,350.9492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -24.133",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path619",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g621",
    transform: "translate(239.2412,303.4536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 2.943,-6.302 9.343,-10.669 16.759,-10.669 7.416,0 13.815,4.367 16.759,10.669",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path623",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 285.605,260.572 h -59.211 v -35.201 h 59.211 z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path625",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "g627",
    transform: "translate(184.0293,312.5615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -17.052,0 -30.875,13.823 -30.875,30.875 -30.875,47.927 -17.052,61.75 0,61.75 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path629",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g631",
    transform: "translate(327.9707,312.5615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 17.052,0 30.875,13.823 30.875,30.875 30.875,47.927 17.052,61.75 0,61.75 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path633",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g635",
    transform: "translate(110.5869,24.9844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 37.592,150.031 c 1.511,6.061 4.386,11.608 8.306,16.275",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path637",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g639",
    transform: "translate(355.5146,191.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 3.921,-4.667 6.796,-10.214 8.307,-16.274 L 45.898,-166.306",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path641",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g643",
    transform: "translate(173.9512,24.9844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 119.68 c 0,17.195 -6.235,33.74 -17.466,46.626 4.134,4.947 9.449,8.906 15.569,11.453 l 54.34,22.625 h 59.211 l 18.859,-7.852",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path645",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g647",
    transform: "translate(334.3555,205.0708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 5.591,-2.328 C 11.71,-4.874 17.025,-8.833 21.159,-13.781 9.929,-26.667 3.693,-43.212 3.693,-60.406 v -119.68",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path649",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g651",
    transform: "translate(226.3945,225.3667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 29.605,-45.154 59.211,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path653",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g655",
    transform: "translate(256,180.2124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -155.229",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path657",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 338.047,78.265 H 173.953 v 46.91 h 164.094 z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path659",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "g661",
    transform: "translate(141.9033,149.9648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -40.611,16.905 H -82.542 L -134.403,-4.683 V -124.981",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path663",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g665",
    transform: "translate(55.7959,191.7993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 49.063 C 63.659,0 75.492,11.833 75.492,26.43 V 72.941 H -26.43 V 26.43 C -26.43,11.833 -14.597,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path667",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g669",
    transform: "translate(19.2139,264.7402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 122.227 c 3.164,0 5.728,2.565 5.728,5.729 v 15.485 c 0,3.164 -2.564,5.729 -5.728,5.729 L 0,26.943 c -3.163,0 -5.729,-2.565 -5.729,-5.729 V 5.729 C -5.729,2.565 -3.163,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path671",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g673",
    transform: "translate(25.1699,303.0566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.97,-3.628 -1.486,-7.44 -1.486,-11.374 h 113.287 c 0,24.268 -19.672,43.939 -43.939,43.939 h -0.057",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path675",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g677",
    transform: "translate(67.6797,335.6221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -0.058 C -7.81,0 -15.094,-2.008 -21.417,-5.532",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path679",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g681",
    transform: "translate(72.6855,348.1938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 15.283 c 2.765,0 5.006,-2.241 5.006,-5.006 V -56.511 H -5.006 V -5.006 C -5.006,-2.241 -2.765,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path683",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g685",
    transform: "translate(80.3271,264.7402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -17.769",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path687",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g689",
    transform: "translate(68.4609,225.1631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 2.084,-4.462 6.615,-7.554 11.866,-7.554 5.251,0 9.782,3.092 11.866,7.554",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path691",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 59.364,191.799 H 101.29 V 166.874 H 59.364 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path693",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "g695",
    transform: "translate(101.29,166.8711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -20.963,-41.696 -41.926,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path697",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g699",
    transform: "translate(80.3271,125.1748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -100.192",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path701",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g703",
    transform: "translate(128.3643,95.9268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -120.864 V -33.216 H -8.325",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path705",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkers);
export default __webpack_public_path__ + "static/media/icon-workers.552a809a6d02268c0245e1ccab6b7b14.svg";
export { ForwardRef as ReactComponent };